import FonMark from '@/components/FonMark';

interface Props {
  label: string;
}

export default function FonLoadingIndicator({ label }: Props) {
  return (
    <div
      className="ai-message flex w-full items-center gap-3 py-2"
      role="status"
      aria-live="polite"
    >
      <FonMark
        alt="FONGPT"
        className="fongpt-logo-loading w-7 h-7 object-contain"
      />
      <span className="animate-pulse text-sm text-secondary">{label}</span>
    </div>
  );
}
